"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _superagent = _interopRequireDefault(require("superagent"));
var _normalizeObject = _interopRequireDefault(require("normalize-object"));
var _lodash = require("lodash");
var _layouts = require("@seedlang/layouts");
var _server_store = _interopRequireDefault(require("./server_store"));
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
var LOG_REACT_NATIVE_REQUESTS = true;
var GENERIC_USER_ERROR_MESSAGE = 'Sorry, an error has occurred. Our developers have been notified. Please contact us at help@seedlang.com if you need any assistance.';
var SIMULATE_MOBILE_AUTH = false;
var Api = (_class = /*#__PURE__*/function () {
  function Api() {
    (0, _classCallCheck2["default"])(this, Api);
    (0, _initializerDefineProperty2["default"])(this, "oustandingRequests", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "csrfToken", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "jwtToken", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "mobileVersionNumber", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "nativeDevice", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "deviceLanguageId", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "isBrowser", _descriptor7, this);
  }
  return (0, _createClass2["default"])(Api, [{
    key: "setJwtToken",
    value: function setJwtToken(jwtToken) {
      this.jwtToken = jwtToken;
    }
  }, {
    key: "setMobileVersionNumber",
    value: function setMobileVersionNumber(mobileVersionNumber) {
      this.mobileVersionNumber = mobileVersionNumber;
    }
  }, {
    key: "setNativeDevice",
    value: function setNativeDevice(nativeDevice) {
      this.nativeDevice = nativeDevice;
    }
  }, {
    key: "setDeviceLanguageId",
    value: function setDeviceLanguageId(deviceLanguageId) {
      this.deviceLanguageId = deviceLanguageId;
    }
  }, {
    key: "ajax",
    value: function ajax(params) {
      var _this = this;
      this.oustandingRequests += 1;
      this.layout = new _layouts.RootLayout();
      var request = this.getRequestByType(params);
      // console.log('request', request);

      if (params.method !== 'GET') {
        request.set('X-CSRF-Token', this.csrfToken);
      }
      if (this.jwtToken && this.layout.isNative) {
        request.set('Authorization', this.jwtToken);
      } else if (SIMULATE_MOBILE_AUTH) {
        if (this.isBrowser) {
          request.set('Authorization', localStorage.getItem('jwtToken'));
        }
      }
      request.set('DEVICE', this.nativeDevice || 'web');
      if (this.mobileVersionNumber) {
        request.set('MOBILE-VERSION', this.mobileVersionNumber);
      }
      if (this.deviceLanguageId) {
        request.set('DEVICE-LANGUAGE-ID', this.deviceLanguageId);
      }
      if (params.onRequestError) {
        request.on('error', params.onRequestError);
      } else {
        request.on('error', this.handleRequestError.bind(this, params));
      }
      request.end(function (err, res) {
        _this.oustandingRequests -= 1;
        // console.log('res', res);
        // ServerStore.setConnectionProblem(err && isPresent(err.toString().match('Error: Request has been terminated')));
        if (res) {
          var resp;
          try {
            resp = _this.toCamel(JSON.parse(res.text));
          } catch (_unused) {
            console.warn('error parsing JSON for URL:', params.url);
          }
          // console.log('after', resp)
          if (resp) {
            if (_this.layout.isNative && LOG_REACT_NATIVE_REQUESTS && __DEV__) {
              console.log(params.method, params.url);
            }
            if (resp.failure && resp.message) {
              if (params.failureCallback) {
                params.failureCallback(resp);
              }
              _server_store["default"].setErrorMessage(resp.message);
            } else {
              if (params.successCallback) {
                if (resp['csrfToken']) {
                  _this.csrfToken = resp['csrfToken'];
                }
                params.successCallback(resp);
              }
              _server_store["default"].setSuccessMessage(resp.message);
            }
          }
        }
        if (params.afterRequestRecieved) {
          params.afterRequestRecieved();
        }
      });
    }
  }, {
    key: "put",
    value: function put(params) {
      this.ajax((0, _lodash.merge)(params, {
        method: 'PUT'
      }));
    }
  }, {
    key: "post",
    value: function post(params) {
      this.ajax((0, _lodash.merge)(params, {
        method: 'POST'
      }));
    }
  }, {
    key: "multipartPost",
    value: function multipartPost(params) {
      this.ajax((0, _lodash.merge)(params, {
        method: 'MULTIPART_POST'
      }));
    }
  }, {
    key: "multipartPostPromise",
    value: function multipartPostPromise(params) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.ajax((0, _lodash.merge)(params, {
          method: 'MULTIPART_POST',
          successCallback: resolve,
          failureCallback: reject,
          onRequestError: reject
        }));
      });
    }
  }, {
    key: "get",
    value: function get(params) {
      this.ajax((0, _lodash.merge)(params, {
        method: 'GET'
      }));
    }
  }, {
    key: "destroy",
    value: function destroy(params) {
      this.ajax((0, _lodash.merge)(params, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "toCamel",
    value: function toCamel(data) {
      if ((0, _lodash.isArray)(data)) {
        return data.map(function (item) {
          return (0, _normalizeObject["default"])(item, 'camel');
        });
      }
      return (0, _normalizeObject["default"])(data, 'camel');
    }
  }, {
    key: "toUnderscore",
    value: function toUnderscore(data) {
      return (0, _normalizeObject["default"])(data, 'snake');
    }
  }, {
    key: "getRequestByType",
    value: function getRequestByType(params) {
      if (this.layout.isNative && __DEV__) {
        params['url'] = "".concat(undefined || 'https://www.seedlang.com').concat(params['url']);
      } else if (this.layout.isNative) {
        params.url = "https://www.seedlang.com".concat(params.url);
      }
      switch (params.method) {
        case 'MULTIPART_POST':
          {
            var request = _superagent["default"].post(params.url).timeout(50000).query(params.queryStrings).send(params.data.data);
            if (params.progressCallback) {
              request.on('progress', params.progressCallback);
            }
            return request;
          }
        case 'GET':
          return _superagent["default"].get(params.url).timeout(20000).query(params.queryStrings).type('json');
        case 'POST':
          return _superagent["default"].post(params.url).timeout(20000).query(params.queryStrings).send(this.toUnderscore(params.data)).type('json');
        case 'PUT':
          return _superagent["default"].put(params.url).timeout(20000).query(params.queryStrings).send(this.toUnderscore(params.data)).type('json');
        case 'DELETE':
          return _superagent["default"]["delete"](params.url).timeout(20000).query(params.queryStrings).type('json');
        default:
          return null;
      }
    }
  }, {
    key: "csrfToken",
    value: function csrfToken() {
      if (!this.layout.isNative) {
        var el = document.head.querySelector('[name=\'csrf-token\']');
        return el ? el.content : null;
      }
    }
  }, {
    key: "handleRequestError",
    value: function handleRequestError(params) {
      if (params.method === 'GET') return;
      _server_store["default"].setUserFriendlyErrorMessage(GENERIC_USER_ERROR_MESSAGE);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "oustandingRequests", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "csrfToken", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "jwtToken", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mobileVersionNumber", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeDevice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "deviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isBrowser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setJwtToken", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setJwtToken"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setMobileVersionNumber", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setMobileVersionNumber"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setNativeDevice", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeDevice"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setDeviceLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setDeviceLanguageId"), _class.prototype), _class);
var _default = exports["default"] = new Api();